<template>
  <div class="agreementList">
    <div class="management-search">
      <div class="management-search-1">
        名称：
        <a-input
          placeholder="请输入名称"
          v-model="name"
          @keyup.enter="query(1)"
          allow-clear
        ></a-input>
      </div>
    </div>
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="margin-left: 20px"></i>
      <a-button type="primary" @click="add">新增</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="false"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="preview(record)">预览</a>
        <a-divider type="vertical" />
        <a href="javascript:;" @click="modifyClick(record)">修改</a>
        <a-divider type="vertical" />
        <a-popconfirm
          placement="right"
          okText="确认"
          cancelText="取消"
          @confirm="deleteClick(record)"
        >
          <template slot="title">是否确认删除{{ record.name }}</template>
          <a href="javascript:;" style="color: #ff4d4f">删除</a>
        </a-popconfirm>
      </span>
    </a-table>
    <!-- 新增 -->
    <a-modal
      :title="title"
      v-model="addKeyVisible"
      :maskClosable="false"
      :afterClose="addKeyClose"
      class="action-class"
      width="800px"
    >
      <a-form>
        <a-form-item
          label="名称:"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-input v-model="nameAdd" placeholder="请输入名称" />
        </a-form-item>
        <a-form-item
          label="编码:"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-input v-model="codeAdd" placeholder="请输入编码" />
        </a-form-item>
        <a-form-item
          label="内容:"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
        >
          <div>
            <quill-editor
              ref="mwQuillEditor"
              v-model="richText"
              :options="editorOption"
            />
          </div>
        </a-form-item>
        <a-form-item
          label="备注:"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-input v-model="remarkAdd" placeholder="请输入备注" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addKeyVisible = false">取消</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="add_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>

    <a-modal
      :title="previewTitle"
      v-model="previewVisible"
      :maskClosable="false"
      class="action-class"
      width="800px"
    >
      <div v-html="previewText" class="agreementContent"></div>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="previewVisible = false">关闭</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import api from "../lib/agreementList.js";

export default {
  name: "agreementList",
  data() {
    return {
      title: "",
      name: "",
      nameAdd: "",
      codeAdd: "",
      richText: "",
      remarkAdd: "",
      groupId: "",
      addKeyVisible: false,
      loading: false,
      pageNo: 1,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "编码",
          dataIndex: "code",
        },
        {
          title: "备注",
          dataIndex: "remark",
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      tableDataSource: [],
      loadingTable: false,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"], // 加粗 斜体 下划线 删除线
            [{ color: [] }, { background: [] }],
            [{ align: [] }], // 对齐方式
          ],
        },
        placeholder: "请输入正文",
      },
      previewVisible: false,
      previewTitle: "",
      previewText: "",
    };
  },
  mounted() {
    this.query(1);
  },
  methods: {
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        name: this.name,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            this.tableDataSource = res.data;
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    preview(val) {
      api.getAgreement({ id: val.id }).then((res) => {
        if (res.result == 200) {
          this.previewText = res.data.preview;
          this.previewTitle = val.name;
          this.previewVisible = true;
        }
      });
    },
    // 修改
    modifyClick(val) {
      api.getAgreement({ id: val.id }).then((res) => {
        if (res.result == 200) {
          this.title = "修改";
          this.richText = res.data.richText;
          this.addKeyVisible = true;
          this.groupId = val.id;
          this.nameAdd = val.name;
          this.codeAdd = val.code;
          this.remarkAdd = val.remark;
        }
      });
    },
    // 新增
    add() {
      this.title = "新增";
      this.addKeyVisible = true;
      this.nameAdd = "";
      this.codeAdd = "";
      this.richText = "";
      this.remarkAdd = "";
    },
    // 确定新增
    add_submit() {
      let data = {
        name: this.nameAdd,
        code: this.codeAdd,
        richText: this.richText,
        remark: this.remarkAdd,
      };
      if (this.title === "新增") {
        api.addData(data).then((res) => {
          if (res.result === 200) {
            this.addKeyVisible = false;
            this.$message.success("添加成功");
            this.query();
          }
        });
      } else {
        data.id = this.groupId;
        api.editData(data).then((res) => {
          if (res.result === 200) {
            this.addKeyVisible = false;
            this.$message.success("修改成功");
            this.query();
          }
        });
      }
    },
    // 关闭新增
    addKeyClose() {
      this.loading = false;
      this.groupId = "";
      this.nameAdd = "";
      this.codeAdd = "";
      this.richText = "";
      this.remarkAdd = "";
    },
    // 点击删除
    deleteClick(val) {
      let data = {
        id: val.id,
      };
      api.deleteData(data).then((res) => {
        if (res.result === 200) {
          this.$message.success("删除成功");
          this.query();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.action-class :deep() .ql-formats {
  margin-right: 0 !important;
  line-height: 24px !important;
}
.action-class :deep() .ql-container {
  height: 350px !important;
}
.agreementContent {
  max-height: 600px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ededed;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #7c7c7c;
  }
}
.agreementList {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
      height: 32px;
      line-height: 32px;
    }
    .backup {
      padding: 5px 0;
    }
    input {
      width: 240px;
    }
    span {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
